module.exports = __webpack_public_path__ + "static/media/Barritas energéticas de piña con linaza.ba0e57c5.jpg";